const Header = ({ theme, title }) => {
  return (
    <h1
      className="bg-white p-5 text-3xl font-bold text-gray-600"
      
    >
      {title}
    </h1>
  );
};

export default Header;
